import React, { useState, useEffect } from 'react';
import { Card, Table, Tag, Space, Button, message, Avatar, Row, Col, Statistic, Segmented } from 'antd';
import { EyeOutlined, UserOutlined } from '@ant-design/icons';
import request from '../utils/request';

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userView, setUserView] = useState('全部');
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  // 获取用户列表
  const fetchUsers = async (page = 1, pageSize = 10) => {
    setLoading(true);
    try {
      const response = await request.get('/admin/user/list', {
        params: { page, pageSize }
      });
      if (response.success) {
        setUsers(response.data.list || response.data || []);
        setPagination(prev => ({
          ...prev,
          total: response.data.total || response.data.length || 0,
        }));
      }
    } catch (error) {
      message.error('获取用户列表失败');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const columns = [
    {
      title: '用户信息',
      key: 'user_info',
      width: 200,
      render: (_, record) => (
        <Space>
          <Avatar 
            src={record.avatar} 
            icon={<UserOutlined />}
            size="default"
          />
          <div>
            <div>{record.nickname || record.username}</div>
            <div style={{ fontSize: '12px', color: '#999' }}>
              {record.phone}
            </div>
          </div>
        </Space>
      ),
    },
    {
      title: '注册时间',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 150,
      render: (date) => new Date(date).toLocaleDateString(),
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      width: 100,
      render: (status) => (
        <Tag color={status === 1 ? 'green' : 'red'}>
          {status === 1 ? '正常' : '禁用'}
        </Tag>
      ),
    },
    {
      title: '操作',
      key: 'action',
      width: 100,
      render: (_, record) => (
        <Space>
          <Button
            type="link"
            size="small"
            icon={<EyeOutlined />}
            onClick={() => message.info('查看详情功能待开发')}
          >
            查看
          </Button>
        </Space>
      ),
    },
  ];

  const activeCount = users.filter(user => Number(user.status) === 1).length;
  const disabledCount = users.filter(user => Number(user.status) !== 1).length;
  const visibleUsers = userView === '正常' ? users.filter(user => Number(user.status) === 1)
    : userView === '已禁用' ? users.filter(user => Number(user.status) !== 1) : users;

  return (
    <div className="workspace-page">
      <div className="workspace-header">
        <div>
          <h1 className="workspace-title">用户管理</h1>
          <p className="workspace-description">查看商城用户资料、联系方式、注册时间和账户状态</p>
        </div>
      </div>

      <Row gutter={[16, 16]} className="workspace-summary">
        <Col xs={12} md={8}><Card size="small"><Statistic title="用户总数" value={pagination.total} /></Card></Col>
        <Col xs={12} md={8}><Card size="small"><Statistic title="当前页正常" value={activeCount} /></Card></Col>
        <Col xs={12} md={8}><Card size="small"><Statistic title="当前页已禁用" value={disabledCount} valueStyle={{ color: disabledCount ? '#c4473d' : '#23855b' }} /></Card></Col>
      </Row>

      <Card className="workspace-data-card">
        <div className="workspace-viewbar">
          <Segmented value={userView} onChange={setUserView} options={['全部', '正常', '已禁用']} />
          <span className="workspace-result-count">当前页 {visibleUsers.length} 位用户</span>
        </div>
      <Table
        columns={columns}
        dataSource={visibleUsers}
        rowKey="id"
        loading={loading}
        scroll={{ x: 650 }}
        pagination={{
          ...pagination,
          onChange: (page, pageSize) => {
            setPagination(prev => ({ ...prev, current: page, pageSize }));
            fetchUsers(page, pageSize);
          },
        }}
      />
      </Card>
    </div>
  );
};

export default UserList;
